<template>
  <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <div>
    <div class="y-f">
      <i class="el-icon-info systemColor y-fs-16 y-mr-5"></i>
      <div>接电商平台通知，小红书平台自<span class="y-fc-F32F52">2月25号</span>起只能使用<span class="y-fc-F32F52">新小红书电子面单</span>打单发货，请您尽快切换。</div>
    </div>
    <div class="y-mt-10 y-ml-20 y-fs-14">为了避免打印异常，<span class="y-fc-F32F52">请勿混合使用新老电子面单</span>。</div>
    <div class="y-mt-20 y-ml-20">
      <el-checkbox v-model="checked"></el-checkbox>
      <span class="y-ml-5 y-c-p" @click="checked=!checked">我知道了，下次不再提醒</span>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">确定</el-button>
    <el-button type="primary" @click="openUrlFn">查看教程</el-button>
  </span>
</el-dialog>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.isShow,
      checked: true,
    }
  },
  watch: {
    isShow(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    handleClose() {
      localStorage.setItem('isXhsKnownNew',  !!this.checked ? 'Y' : 'N');
      this.dialogVisible = false;
      this.$emit('close');
    },
    openUrlFn() {
      window.open('https://kh.yto.net.cn/new/helpCenter?typeId=33&problemId=323', '_blank');
    }
  }
}
</script>
<style lang="scss" scoped>
.customTooptip {
  position:absolute;
  top: 40px;
  left: 90%;
  z-index: 100;
  width: 304px;
  background-color: $white;
  padding: 10px;
  box-shadow: 0px 1px 11px 0px rgba(109, 140, 209, 0.22);
  border-radius: 3px;
  .tooltip-title {
    padding: 10px;
    text-align: left;
  }
  .customTooptip-footer {
    margin-top: 10px;
    text-align: right;
    .btn {
      display: inline-block;
      height: 26px;
      line-height: 26px;
      width: 58px;
      color: $color-style;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
    }
    .btn.primary {
      border: 1px solid $blue-style;
      background-color: $blue-style;
      color: $white;
      margin-left: 10px;
    }
  }
}
</style>
